
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
directives: {
TransferDom
},
components: {
XDialog
},
created() {
this.time = setInterval(() => {
console.log(document.visibilityState)
}, 1000)
},
destroyed() {
window.clearInterval(this.time)
},
data() {
return {
showDialogStyle: false
}
},
methods: {
showWrap() {
this.$http.getFollowConfig().then(res => {
if (res.data.data) {
this.$store.commit('SET_FOLLOWCONFIG', res.data.data)
this.toast('你已关注公众号')
} else {
this.showDialogStyle = true
}
})
},
closeWrap() {
this.$http.getFollowConfig().then(res => {
if (res.data.data) {
this.$store.commit('SET_FOLLOWCONFIG', res.data.data)
this.toast('你已关注公众号')
} else {
this.showDialogStyle = false
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/FollwDialog.vue